import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'arrayKeys',
    standalone: false
})
export class ArrayKeysPipe implements PipeTransform {
  transform(value: {[key: string]: any} | boolean = {}): string[] {
    return Object.keys(value);
  }
}
